import React, { useEffect, useState } from 'react';
import HomeLayout from '../Layouts/homeLayout';
import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import { styled } from '@mui/material/styles';
import AddPlan from './AddPlan';
import { getCustomPlan, updateCustomPlan } from '../../actions/userActions';
import IconButton from '@mui/material/IconButton';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ConfirmAlert from '../common/confirmAlert';
import { toast } from 'react-toastify';
import EditPlan from './EditPlan';

const columns = [
	{ id: 'title', label: 'Plan Name', minWidth: 170 },
	{ id: 'license', label: 'Plan License', minWidth: 170, format: (value) => formatPlanWithCount(value) },
	{ id: 'code', label: 'Code', minWidth: 100 },
	{ id: 'active', label: 'Status', minWidth: 100, format: (value) => (value ? 'Active': 'Inactive') }
];

function formatPlanWithCount(value)
{
	if (!value || value.length === 0)
	{

		return 'No Package';
	}

	// Create a formatted string with plan names and counts

	const result = value
		.map(({ planName, months }) => (months > 1 ? `${planName} (${months})` : planName))
		.join(', ');

	return result;
	// return value
	// 	.map(([ planName, months ]) => (months > 1 ? `${planName} (${months})` : planName))
	// 	.join(', ');

}

const StyledTableCell = styled(TableCell)(({ theme }) => ({
	[`&.${tableCellClasses.head}`] : {
		backgroundColor : theme.palette.common.black,
		color           : theme.palette.common.white
	},
	[`&.${tableCellClasses.body}`] : {
		fontSize : 14
	}
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
	'&:nth-of-type(odd)' : {
		backgroundColor : theme.palette.action.hover
	},
	// hide last border
	'&:last-child td, &:last-child th' : {
		border : 0
	}
}));

const PlanManagement = () =>
{
	const [ search, setSearch ] = useState('');
	const [ openNew, setOpenNew ] = useState(false);
	const [ data, setData ] = useState([]);
	const [ page, setPage ] = React.useState(0);
	const [ rowsPerPage, setRowsPerPage ] = React.useState(10);
	const [ totalCount, setTotalCount ] = useState(1);
	const [ menuOpen, setMenuOpen ] = useState(null);
	const [ anchorEl, setAnchorEl ] = React.useState(null);
	const [ selectedData, setSelectedData ] = useState(null);
	const [ deleteModel, setDeleteModel ] = useState(false);
	const [ editPlan, setEditPlan ] = useState(false);

	useEffect(() =>
	{
		getCustomPlan(search, page, rowsPerPage).then((res) =>
		{
			if (res?.data?.status)
			{
				setData(res?.data?.data);
				setTotalCount(res?.data?.pagination?.total);
			}
			else
			{
				setData([]);
			}
		})
			.catch((err) =>
			{
				// eslint-disable-next-line quotes, no-console
				console.log("err ==== ", err);
				setData([]);
			});
	}, [ openNew, search, page, rowsPerPage, deleteModel, editPlan ]);

	const handleChangePage = (event, newPage) =>
	{
		setPage(newPage);
	};

	const handleChangeRowsPerPage = (event) =>
	{
		setRowsPerPage(Number(event.target.value));
		setPage(0);
	};

	const handleMenuClose = () =>
	{
		setMenuOpen(null);
		setAnchorEl(null);
	};

	const handleUserMenu = (event, id) =>
	{
		setMenuOpen(id);
		setAnchorEl(event.currentTarget);
		// eslint-disable-next-line quotes, no-console
		// console.log('id', id);
		// eslint-disable-next-line quotes, no-console
		// console.log('event.currentTarge', event.currentTarget);
	};

	const handleUpdatePlan = () =>
	{
		updateCustomPlan({ id: selectedData?._id, active: !selectedData?.active }).then((res) =>
		{

			if (res?.data?.status)
			{
				toast.success(res?.data?.message);
				setDeleteModel(false);
			}
			else
			{
				toast.error(res.data.message);
			}
		})
			.catch((err) =>
			{
				// eslint-disable-next-line quotes, no-console
				console.log('err === ', err);
				toast.error('Internal server error, Please try again');
			});
	};

	return (
		<div className='flexCol pdngSM fullHeight'>
			<div className='users-top-bar'>
				<div className='search-section'>
					<input id='search' type='search' placeholder='Search...' onChange={(e) => { setSearch(e.target.value); setPage(0); }}/>
				</div>
				<div className='button-section'>
					<Button
						variant='contained'
						size='small'
						title='Create User'
						onClick={() => setOpenNew(true)}
					>Add Package</Button>
				</div>
			</div>
			<Paper sx={{ width: '100%', overflow: 'hidden' }}>
				<TableContainer sx={{ maxHeight: 440 }}>
					<Table stickyHeader aria-label='sticky table'>
						<TableHead>
							<TableRow>
								{columns.map((column) => (
									<StyledTableCell
										key={column.id}
										align={column.align}
										style={{ minWidth: column.minWidth }}
									>
										{column.label}
									</StyledTableCell>
								))}
								<StyledTableCell />
							</TableRow>
						</TableHead>
						<TableBody>
							{data.map((row) =>
								(<StyledTableRow hover role='checkbox' tabIndex={-1} key={row._id}>
									{columns.map((column) =>
									{
										const value = row[column.id];

										return (
											<StyledTableCell key={column.id} align={column.align}>
												{column.format
													? column.format(value)
													: value}
											</StyledTableCell>
										);
									}
									)}
									<StyledTableCell>
										<IconButton
											aria-label='more'
											id='long-button'
											aria-haspopup='true'
											aria-controls={menuOpen !== null ? 'long-menu' : undefined}
											aria-expanded={menuOpen !== null ? 'true' : undefined}
											onClick={(e) => { handleUserMenu(e, row._id); setSelectedData(row); }}
										>
											<MoreVertIcon />
										</IconButton>
										<Menu
											id='long-menu'
											MenuListProps={{
												'aria-labelledby' : 'long-button'
											}}
											// PaperProps={{
											// 	style : {
											// 		maxHeight : ITEM_HEIGHT * 4.5,
											// 		width     : '20ch'
											// 	}
											// }}
											anchorEl={anchorEl}
											open={menuOpen === row._id}
											onClose={handleMenuClose}
										>
											<MenuItem onClick={() => { setDeleteModel(true); setMenuOpen(null); setAnchorEl(null); }}>
												{row.active ?'Deactivate': 'Activate'}
											</MenuItem>
											<MenuItem onClick={() => { setEditPlan(true); setMenuOpen(null); setAnchorEl(null); }}>
												Edit Plan
											</MenuItem>
										</Menu>
									</StyledTableCell>
								</StyledTableRow>)
							)}
						</TableBody>
					</Table>
				</TableContainer>
				<TablePagination
					rowsPerPageOptions={[ 10, 25, 100 ]}
					component='div'
					count={totalCount}
					rowsPerPage={rowsPerPage}
					page={page}
					onPageChange={handleChangePage}
					onRowsPerPageChange={handleChangeRowsPerPage}
				/>
			</Paper>
			<AddPlan openNew={openNew} setOpenNew={setOpenNew}/>
			<EditPlan openNew={editPlan} setOpenNew={setEditPlan} selectedData={selectedData}/>
			<ConfirmAlert
				open={deleteModel}
				content={`Do you really want to ${selectedData?.active ? 'deactivate':'activate'} plan?`}
				handleOk={handleUpdatePlan}
				handleCancel={() => setDeleteModel(false)}
			/>
		</div>
	);
};

export default HomeLayout(PlanManagement);
